/**
 * Generated runtime TestId mirror for frontend/src/pages/RequestInspector.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RequestInspectorTestIds = {
  btnRefresh: "btn-refresh",
  colEarliestStartedAt: "col-earliest-started-at",
  colErrorCount: "col-error-count",
  colSessionId: "col-session-id",
  colSpanCount: "col-span-count",
  colTotalDuration: "col-total-duration",
  emptyStateCard: "empty-state-card",
  inspectorMinQHint: "inspector-min-q-hint",
  inspectorSearchScopeHint: "inspector-search-scope-hint",
  pageLayoutFilters: "page-layout-filters",
  requestInspectorList: "request-inspector-list",
  requestInspectorPage: "request-inspector-page",
  tracesTable: "traces-table",
  writerOfflineAlert: "writer-offline-alert",
  traceRow: (item_sessionId: string) => `trace-row-${item_sessionId}`,
  traceRowPrefix: () => "trace-row-" as TestIdPrefix
} as const;
